__turbopack_context__.v({
  "agenciesBackground": "Agencies-module__DHVg3q__agenciesBackground",
  "innerPadding": "Agencies-module__DHVg3q__innerPadding",
  "text": "Agencies-module__DHVg3q__text",
});
